import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIEText from '@src/shared/components/PIEText';
import PIEToggler from '@src/shared/components/PIEToggler';
import React, { useState } from 'react';
export interface FAQItem {
  question: string;
  answer: string;
}
interface componentProps {
  faqItems?: FAQItem[];
}
const DashboardFAQList: React.FC<componentProps> = ({ faqItems = [] }) => {
  const [selectedFAQItem, setSelectedFAQItem] = useState<number | null>(null);
  return (
    <div>
      {faqItems.map((item, index) => (
        <PIEComponentUtil
          marginLeft="var(--xds-spacing-b)"
          marginRight="var(--xds-spacing-b)"
          marginBottom="var(--xds-spacing-a)"
          key={index}
        >
          <PIEToggler
            modSeparator={index !== 0 ? true : false}
            modFullBorder={false}
            label={
              <PIEText
                size={'var(--xds-font-size-14)'}
                fontWeight="var(--xds-font-weight-bold)"
                text={item.question}
              />
            }
            isOpen={selectedFAQItem === index}
            isActive={selectedFAQItem === index}
            key={index}
            onToggleClick={() => {
              setSelectedFAQItem(selectedFAQItem === index ? null : index);
            }}
          >
            <PIEComponentUtil
              marginTop="var(--xds-spacing-d)"
              marginRight="var(--xds-spacing-b)"
              marginBottom="var(--xds-spacing-c)"
            >
              <div style={{ minHeight: '50px' }}>
                <PIEText size={'var(--xds-font-size-14)'} text={item.answer} />
              </div>
            </PIEComponentUtil>
          </PIEToggler>
        </PIEComponentUtil>
      ))}
    </div>
  );
};

export default DashboardFAQList;
